<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>KARYAT TULIS</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Karya Tulis</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.judul.$error}">
            <label> Judul </label>
            <j-input
              v-model="$v.data_master.judul.$model"
              placeholder="Judul"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun.$error}">
            <label> Tahun Pembuatan </label>
            <j-input
              v-model="$v.data_master.tahun.$model"
              type="number"
              placeholder="Tahun Pembuatan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.publikasi.$error}">
            <label> Publikasi </label>
            <j-input
              v-model="$v.data_master.publikasi.$model"
              placeholder="Publikasi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.keterangan.$error}">
            <label> Keterangan </label>
            <j-input
              v-model="$v.data_master.keterangan.$model"
              placeholder="Keterangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.url_publikasi.$error}">
            <label> URL Publikasi </label>
            <j-input
              v-model="$v.data_master.url_publikasi.$model"
              placeholder="URL Publikasi"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Karya Tulis</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.judul.$error}">
            <label> Judul </label>
            <j-input
              v-model="$v.data_master.judul.$model"
              :disabled="readOnly"
              placeholder="Judul"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun.$error}">
            <label> Tahun Pembuatan </label>
            <j-input
              v-model="$v.data_master.tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Tahun Pembuatan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.publikasi.$error}">
            <label> Publikasi </label>
            <j-input
              v-model="$v.data_master.publikasi.$model"
              :disabled="readOnly"
              placeholder="Publikasi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.keterangan.$error}">
            <label> Keterangan </label>
            <j-input
              v-model="$v.data_master.keterangan.$model"
              :disabled="readOnly"
              placeholder="Keterangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.url_publikasi.$error}">
            <label> URL Publikasi </label>
            <j-input
              v-model="$v.data_master.url_publikasi.$model"
              :disabled="readOnly"
              placeholder="URL Publikasi"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jKaryaTulis',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['judul', 'tahun', 'publikasi', 'keterangan', 'url_publikasi'],
      options: {
        headings: {
          judul: 'JUDUL',
          tahun: 'TAHUN PEMBUATAN',
          publikasi: 'PUBLIKASI',
          keterangan: 'KETERANGAN',
          url_publikasi: 'URL PUBLIKASI',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['judul', 'tahun', 'publikasi', 'keterangan', 'url_publikasi'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListKaryaTulis(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        judul: '',
        tahun: null,
        publikasi: '',
        keterangan: '',
        url_publikasi: '',
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createKaryaTulis', 'updateKaryaTulis', 'deleteKaryaTulis']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        judul: '',
        tahun: null,
        publikasi: '',
        keterangan: '',
        url_publikasi: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        judul: '',
        tahun: null,
        publikasi: '',
        keterangan: '',
        url_publikasi: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        judul: param.row.judul,
        tahun: param.row.tahun,
        publikasi: param.row.publikasi,
        keterangan: param.row.keterangan,
        url_publikasi: param.row.url_publikasi,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createKaryaTulis(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updateKaryaTulis(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteKaryaTulis(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        judul: { required },
        tahun: { required },
        publikasi: { required },
        keterangan: { required },
        url_publikasi: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jKaryaTulis.vue